import { AxiosError } from 'axios';
import { GET_NON_NATIONAL_EXAM_RECEIPT_DETAILS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_NON_NATIONAL_EXAM_RECEIPT_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import { GenericErrorResponse } from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface NonNationalExamReceiptDetailsResponse {
  transactionNumber: string;
  internalTransactionRef: string;
  totalFee: string;
  paymentMethod: string;
  paymentTimeStamp: string;
  gstRegNo: string;
  paymentStatus: string;
  registrationUuid: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: NonNationalExamReceiptDetailsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const useGetNonNationalExamReceiptDetails = ({ uuid, onSuccess, onError }: Input) => {
  const getNonNationalExamReceiptDetails = async () => {
    const res = await axiosClient.get<NonNationalExamReceiptDetailsResponse>(
      GET_NON_NATIONAL_EXAM_RECEIPT_DETAILS(uuid)
    );
    return res.data;
  };
  return useCustomQuery(
    [GET_NON_NATIONAL_EXAM_RECEIPT_DETAILS_QUERY_KEY],
    getNonNationalExamReceiptDetails,
    {
      onSuccess,
      onError,
    }
  );
};
